const claims = {
  tabLabel: "Verbindlichkeiten",
  header: {
    claimsCount: "{{count}} Forderungen",
    totalAmount: "Gesamtsumme {{amount}} €",
    totalAmountLabel: "Gesamtsumme",
  },
  toolbar: {
    search: "Gläubiger, Vertreter oder Aktenzahl suchen...",
    showCompleted: "Erledigte anzeigen",
    srvRegistered: "SRV angemeldet",
    carryForward: "Saldo fortschreiben",
    applySurcharge: "Saldo aufschlagen",
    newClaim: "Neue Forderung",
  },
  table: {
    creditor: "Gläubiger",
    representative: "Vertreter",
    caseNumber: "Aktenzahl",
    legalBasis: "Rechtsgrund",
    srvOrderNumber: "ON",
    currentSaldo: "Saldo",
    disputedAmount: "Strittig",
    total: "Gesamtsumme",
    inactiveCreditor: "Gläubiger inaktiv",
    inactiveRepresentative: "Vertreter inaktiv",
  },
  empty: "Keine Forderungen vorhanden",
  create: {
    dialogTitle: "Forderung erfassen",
    successfullyCreated: "Forderung wurde erfolgreich erfasst.",
  },
  edit: {
    dialogTitle: "Forderung bearbeiten",
    successfullyUpdated: "Forderung wurde erfolgreich gespeichert.",
    successfullyCompleted: "Forderung wurde als erledigt markiert.",
    successfullyReopened: "Forderung wurde als offen markiert.",
    balanceListChanged:
      "Die Saldenliste dieser Forderung wurde zwischenzeitlich geändert. Die Forderung wurde neu geladen, nicht gespeicherte Änderungen wurden dabei zurückgesetzt. Bitte erfassen Sie sie erneut.",
    saveFailed: "Forderung konnte nicht gespeichert werden.",
    markAsCompleted: "Als erledigt markieren",
    markAsOpen: "Als offen markieren",
    delete: "Löschen",
  },
  delete: {
    dialogTitle: "Forderung löschen?",
    dialogText:
      "Möchten Sie die Forderung gegen <strong>{{creditorName}}</strong> wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    confirm: "Löschen",
    cancel: "Abbrechen",
    successfullyDeleted: "Forderung wurde erfolgreich gelöscht.",
  },
  form: {
    creditor: "Gläubiger",
    representative: "Vertreter",
    date: "Datum",
    amount: "Betrag",
    caseNumber: "Aktenzahl",
    legalBasis: "Rechtsgrund",
    disputedStatus: "Strittig",
    collateralStatus: "Gibt es Sicherheiten?",
    srvRegistrationStatus: "Im SRV angemeldet",
    srvOrderNumber: "Ordnungsnummer",
    notes: "Anmerkung",
    claimEntirelyDisputedSection: "STRITTIGE FORDERUNG",
    claimEntirelyDisputed: "Forderung zur Gänze strittig",
    statusOptions: {
      yes: "Ja",
      no: "Nein",
      unknown: "Unbekannt",
    },
    recognizedAmount: "Anerkannter Betrag",
    collateralSection: "SICHERHEITEN",
    balanceHistorySection: "SALDO-HISTORIE",
    // One participant field serves both Gläubiger and Vertreter; {{entity}} is the field's noun so
    // the copy follows whichever one is being edited.
    participantSearch: "{{entity}} suchen...",
    noParticipantResults: 'Kein Treffer für "{{query}}"',
    noParticipantResultsPressEnter:
      'Kein Treffer für "{{query}}". Drücken Sie Enter, um einen kundenspezifischen {{entity}} anzulegen.',
    createClientSpecificParticipant: "Kundenspez. {{entity}} anlegen",
    editClientSpecificParticipant: "Kundenspezifischen {{entity}} bearbeiten",
    inactiveRepresentative: "Vertreter ist inaktiv – bitte anderen wählen oder Auswahl entfernen",
  },
  collaterals: {
    collateralStatus: "Gibt es Sicherheiten?",
    statusUnknown: "Weiß nicht",
    expectedLoss: "Wie hoch ist der vermutliche Ausfall?",
    blockTitleUnset: "Sicherheit — Art noch nicht gewählt",
    type: "Welcher Art ist die Sicherheit?",
    remove: "Sicherheit entfernen",
    add: "Sicherheit hinzufügen",
    count_one: "{{count}} Sicherheit erfasst",
    count_other: "{{count}} Sicherheiten erfasst",
    types: {
      BuildingSavingsContract: "Bausparvertrag",
      LifeInsurance: "Lebensversicherung",
      PensionInsurance: "Pensionsvorsorgeversicherung",
      SavingsAccount: "Sparbuch",
      Securities: "Wertpapiere",
      RealEstate: "Immobilie (Haus, Eigentumswohnung, Grundbesitz etc.)",
      WagePledge: "vertragliches Pfandrecht am Lohn/Gehalt",
      Other: "anderes",
    },
    holdingQuestion: {
      BuildingSavingsContract: "Welcher Bausparvertrag dient als Sicherheit?",
      LifeInsurance: "Welche Lebensversicherung dient als Sicherheit?",
      PensionInsurance: "Welche Pensionsvorsorgeversicherung dient als Sicherheit?",
      SavingsAccount: "Welches Sparbuch dient als Sicherheit?",
      Securities: "Welches Wertpapierdepot dient als Sicherheit?",
    },
    newHoldingOption: {
      BuildingSavingsContract: "anderer Bausparvertrag — neu anlegen",
      LifeInsurance: "andere Lebensversicherung — neu anlegen",
      PensionInsurance: "andere Pensionsvorsorgeversicherung — neu anlegen",
      SavingsAccount: "anderes Sparbuch — neu anlegen",
      Securities: "anderes Wertpapierdepot — neu anlegen",
    },
    details: {
      RealEstate: "Nähere Angaben zu der als Sicherheit dienenden Immobilie",
      WagePledge: "Name des Dienstgebers (Drittschuldner), bei dem das vertragliche Pfandrecht offengelegt wurde",
      Other: "Nähere Angaben zu der sonstigen Sicherheit",
    },
    holdingInstitutionMissing: "Bank/Versicherungsname fehlt",
    holdingNumberMissing: "Nummer fehlt",
    newHolding: {
      title: "Neuer Vermögenswert — wird ins Vermögensverzeichnis übernommen",
      selectionBank: "zur Auswahl: Bank",
      selectionInsurance: "zur Auswahl: Versicherung",
      institutionBank: "Name der Bank",
      institutionInsurance: "Name der Versicherung",
      accountNumber: "Kontonummer",
      depotNumber: "Depotnummer",
      policyNumber: "Polizzennummer",
      street: "Straße",
      houseNumber: "Hausnummer",
      zipCode: "PLZ",
      city: "Ort",
      country: "Land",
      isValueKnown: "Ist der genaue aktuelle Wert bekannt?",
      value: "Höhe des aktuellen Wertes",
      valueDate: "per Stichtagsdatum",
      remarks: "weitere Angaben",
      valueUnknownHint: "Der aktuelle Wert ist bei der Bank zu erfragen und nachzutragen.",
    },
  },
  validation: {
    expectedLossRange: "Bitte geben Sie einen Wert zwischen {{min}} und {{max}} % ein.",
    srvRequiresRegisteredEntry:
      'Bei "Im SRV angemeldet: Ja" muss die Saldo-Historie einen Eintrag mit Typ "angemeldet" enthalten.',
    singleRegisteredEntry: 'Die Saldo-Historie darf nur einen Eintrag mit Typ "angemeldet" enthalten.',
  },
  surcharge: {
    dialogTitle: "Saldo aufschlagen",
    description:
      "Legt bei den ausgewählten Forderungen einen neuen Saldo-Eintrag mit dem ausgewählten Datum an. Der Betrag ergibt sich aus dem letzten Saldo zuzüglich Aufschlag.",
    loading: "Forderungen werden geladen",
    percentage: "Aufschlag",
    date: "Datum",
    entryType: "Art des neuen Eintrags",
    creditor: "Gläubiger",
    balance: "Saldo",
    skippedNoHistory: "keine Saldo-Historie → wird übersprungen",
    skippedHint_one:
      "{{count}} der {{selected}} ausgewählten Forderungen hat keine Saldo-Historie und wird übersprungen.",
    skippedHint_other:
      "{{count}} der {{selected}} ausgewählten Forderungen haben keine Saldo-Historie und werden übersprungen.",
    nothingToApply_one:
      "Die ausgewählte Forderung hat keine Saldo-Historie – es kann kein Aufschlag angewendet werden.",
    nothingToApply_other:
      "Keine der {{count}} ausgewählten Forderungen hat eine Saldo-Historie – es kann kein Aufschlag angewendet werden.",
    previewTitle: "VORSCHAU",
    affectedCount_one: "{{count}} Forderung betroffen",
    affectedCount_other: "{{count}} Forderungen betroffen",
    newTotal: "Neue Gesamtsumme nach Aufschlag",
    difference: "Differenz",
    submit: "Aufschlag anwenden",
    successfullyApplied_one: "Der Saldo von {{count}} Forderung wurde aufgeschlagen: {{previousTotal}} → {{newTotal}}.",
    successfullyApplied_other:
      "Der Saldo von {{count}} Forderungen wurde aufgeschlagen: {{previousTotal}} → {{newTotal}}.",
    failed: "Der Aufschlag konnte nicht angewendet werden. Die Liste wurde aktualisiert – bitte erneut versuchen.",
    registeredTypeUnavailable:
      "Nicht per Aufschlag vergebbar — jede Forderung darf nur einen Eintrag dieses Typs haben.",
    // The entry lands in the middle of the history when its date is older than the newest entry, so
    // the balance the list shows stays where it is. Named with both counts and a way out, because it
    // is also what explains a preview showing no difference at all.
    pastDateHint_one:
      "Bei {{unchanged}} von {{count}} Forderung liegt das gewählte Datum vor dem jüngsten Eintrag der Saldo-Historie. Dort bleibt der angezeigte Saldo unverändert — der neue Eintrag wird in die Historie eingeordnet. Wählen Sie ein späteres Datum, um den Saldo zu erhöhen.",
    pastDateHint_other:
      "Bei {{unchanged}} von {{count}} Forderungen liegt das gewählte Datum vor dem jüngsten Eintrag der Saldo-Historie. Dort bleibt der angezeigte Saldo unverändert — der neue Eintrag wird in die Historie eingeordnet. Wählen Sie ein späteres Datum, um den Saldo zu erhöhen.",
    validation: {
      percentageRequired: "Bitte geben Sie einen Aufschlag größer als 0 ein.",
    },
  },
  carryForward: {
    dialogTitle: "Saldo fortschreiben",
    description_one:
      "Legt bei der ausgewählten Forderung einen neuen Saldo-Eintrag mit dem heutigen Datum (<strong>{{date}}</strong>) an. Betrag und Typ werden vom letzten Eintrag übernommen.",
    description_other:
      "Legt bei den {{count}} ausgewählten Forderungen einen neuen Saldo-Eintrag mit dem heutigen Datum (<strong>{{date}}</strong>) an. Betrag und Typ werden vom letzten Eintrag übernommen.",
    loading: "Forderungen werden geladen",
    creditor: "Gläubiger",
    balance: "Saldo",
    date: "Datum",
    skippedAlreadyUpToDate: "Saldo bereits aktuell → wird übersprungen",
    skippedNoHistory: "keine Saldo-Historie → wird übersprungen",
    skippedHint_one:
      "{{count}} der {{selected}} ausgewählten Forderungen kann nicht fortgeschrieben werden und wird übersprungen.",
    skippedHint_other:
      "{{count}} der {{selected}} ausgewählten Forderungen können nicht fortgeschrieben werden und werden übersprungen.",
    nothingToCarryForward_one: "Bei der ausgewählten Forderung kann der Saldo nicht fortgeschrieben werden.",
    nothingToCarryForward_other:
      "Bei keiner der {{count}} ausgewählten Forderungen kann der Saldo fortgeschrieben werden.",
    submit: "Auf heute setzen",
    successfullyCarriedForward_one: "Der Saldo von {{count}} Forderung wurde auf {{date}} fortgeschrieben.",
    successfullyCarriedForward_other: "Der Saldo von {{count}} Forderungen wurde auf {{date}} fortgeschrieben.",
    successfullyCarriedForwardPartially:
      "Der Saldo von {{count}} von {{selected}} Forderungen wurde auf {{date}} fortgeschrieben, {{skipped}} übersprungen.",
    failed: "Der Saldo konnte nicht fortgeschrieben werden. Die Liste wurde aktualisiert – bitte erneut versuchen.",
  },
  balanceHistory: {
    date: "Datum",
    amount: "Betrag",
    entryType: "Typ",
    addRow: "+ Zeile hinzufügen",
    summaryCount_one: "{{count}} Eintrag",
    summaryCount_other: "{{count}} Einträge",
    summaryBefore_one: "{{count}} Eintrag · Aktueller Saldo",
    summaryBefore_other: "{{count}} Einträge · Aktueller Saldo",
    summaryAfter: "({{date}})",
  },
};

export default claims;
